module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 5.8b138538.wav";